<template>
  <div class="spelttjlaw">
    <div class="tjlawtit between">
      <div>推荐律师</div>
      <div class="mo">更多></div>
    </div>
    <div class="tjlawlist">
      <div class="tjlawitem flex_start" v-for="item in 5" :key="item">
        <div class="cov">
          <img src="../../../assets/special/lvshicover_sample.png" />
        </div>
        <div class="rtxt">
          <div>张三律师</div>
          <div class="rrr2">帮助过1234人 | 123次好评</div>
          <div class="ellipsis FontSize14">专长：婚姻家庭、劳动纠纷...</div>
        </div>
        <div class="lsstatus"><span>接单中</span></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.spelttjlaw {
  width: 100%;
  padding: 20px;
  .tjlawtit {
    font-size: 18px;
    color: #333333;
    padding: 10px 0 20px;
    .mo {
      font-size: 14px;
      color: #bbbbbb;
    }
  }
  .tjlawlist {
    .tjlawitem {
      border-top: 1px solid #eee;
      padding: 20px 0;
      cursor: pointer;
      position: relative;
      .cov {
        margin-right: 10px;
        img {
          width: 72px;
          height: 72px;
        }
      }
      .rtxt {
        width: 190px;
        color: #333333;
        .rrr2 {
          margin: 10px 0 6px;
          font-size: 12px;
          color: #bbbbbb;
        }
      }
      .lsstatus {
        position: absolute;
        top: 15px;
        right: 5px;
        font-size: 12px;
        color: #333333;
        &:before {
          content: "";
          position: absolute;
          top: 6px;
          left: -12px;
          width: 6px;
          height: 6px;
          background: #05dd00;
          border-radius: 50%;
        }
      }
    }
  }
}
</style>